const ANYTIME = 'ANYTIME';

export default ANYTIME;
